
import React from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';
import DisclaimerForm from '../components/DisclaimerForm';

const Disclaimer = () => {
  const { t } = useTranslation();
  return (
    <Layout title={t("common:disclaimer.title")}>
      <DisclaimerForm />
    </Layout>
  );
};

export default Disclaimer;
